// Copyright (c) 2018 Nutanix Inc. All rights reserved.
//
// Not Found Page - Notifies the user that they attempted to access a page that
// could not be found.
//

// Libs
import React from 'react';
import PropTypes from 'prop-types';
import { FlexLayout, AlertIcon, StarIcon, CheckMarkIcon } from '@nutanix-ui/prism-reactjs';

import './Toaster.less';

export default class Toaster extends React.PureComponent {
    static propTypes = {
        text: PropTypes.string,
        type: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
    };

    static defaultProps = {
        text: 'A toaster',
        type: 'info',
    };

    getIcon(type) {
        if (type === 'danger') {
            return <AlertIcon className={type} />;
        } else if (type === 'warning') {
            return <AlertIcon className={type} />;
        } else if (type === 'success') {
            return <CheckMarkIcon className={type} />;
        }

        return <StarIcon className={type} />;
    }

    render() {
        const { text, type } = this.props;
        return (
            <FlexLayout className="Toaster" itemGap="S" alignItems="flex-start">
                <div className={`toaster-icon-container ${type}`}>{this.getIcon(type)}</div>
                <span>{text}</span>
            </FlexLayout>
        );
    }
}
